var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="category--overview_chart_left"> <div class="graph-title"> <p><i class="fa fa-circle" aria-hidden="true"></i> Internet and Mobile Ecosystem Companies</p> </div> </div> <div id="category--overview_chart_right"> <div class="graph-title"> <p><i class="fa fa-circle" aria-hidden="true"></i> Telecommunications companies</p> </div> </div>';
}
return __p;
};
